module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/tools/shovel-d959cb9045be28c3e8b33aca16385209.svg";